var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionDialog',{attrs:{"bubble-icon":{
    icon: _vm.Icon.CircleDot,
    colour: 'default',
  },"header":_vm.$tc('modal.heading.requestOpenShift'),"primary-button":{
    label: _vm.shift.requiresApproval
      ? _vm.$tc('button.requestOpenShift')
      : _vm.$tc('button.claimOpenShift'),
    colour: 'pink',
    disabled: !!_vm.conflictMessage || _vm.submitting,
    action: () => _vm.respond(),
  },"secondary-action":{
    label: _vm.$t('button.cancel'),
    action: () => (_vm.open = false),
    colour: 'transparent',
  }},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('OpenShiftResponseDetails',{attrs:{"shift":_vm.shift,"conflict-message":_vm.conflictMessage}})]},proxy:true}]),model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})
}
var staticRenderFns = []

export { render, staticRenderFns }